/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { BigModal } from './BigModal';
import { ModalButton } from './ModalButton';
import { Typography, Grid, MenuItem } from '@mui/material';
import { CustomTextField } from '../index';
import { apiUrl } from '../../utilities/apiUrl';
import { useState } from 'react';
import { useAlert } from '../../providers/AlertContext';

export const OtpModal = (props) => {
  const [otp, setOtp] = useState('');
  const { showAlert } = useAlert();

  // ADD EMPLOYEE SUBMIT HANDLER
  const handleSubmit = () => {
    fetch(apiUrl('/auth/verify'), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        otp: otp,
        empid: props.empId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          window.location.replace('/dashboard');
        } else {
          if (data.message == 'Error. Invalid OTP.') {
            showAlert('Please verify your OTP.', 'warning', 'Invalid OTP');
          }
        }

        setIsSending(false);
      });
  };

  return (
    <>
      <BigModal open={props.open} onClose={props.onClose}>
        <Typography sx={{ mb: 2, fontWeight: 600 }} variant="h5">
          Two-Factor Authentication
        </Typography>
        <Grid container>
          <Grid item xs={12} sx={{ px: 2 }}>
            <Grid item sx={{ mr: 1.4 }}>
              <CustomTextField
                error={!otp}
                errorMsg={'Please enter your OTP'}
                label={'OTP'}
                onChange={(event) => {
                  setOtp(event.target.value);
                }}
                onFocus={true}
                required={true}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && otp) {
                    handleSubmit();
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <ModalButton
          primaryBtnName="Submit"
          secondaryBtnName="Cancel"
          primaryClickHandler={() => {
            handleSubmit();
          }}
          secondaryClickHandler={props.onClose}
          // Ensures all fields are properly filled before submit button becomes available
          disable={!otp}
        />
      </BigModal>
    </>
  );
};
